function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Notification",
  transform: "translate(0.31 0.3)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "M6.962,23.937H.855a.846.846,0,0,1-.835-.644.8.8,0,0,1,.445-.911,4.381,4.381,0,0,0,1.343-1.808c1.156-2.422,1.4-5.833,1.4-8.268a7.977,7.977,0,0,1,4.75-7.269v-1.9A3.151,3.151,0,0,1,11.119,0h.263a3.151,3.151,0,0,1,3.162,3.133v1.9a7.978,7.978,0,0,1,4.749,7.238c0,.011,0,.022,0,.031,0,2.435.243,5.846,1.4,8.268a4.381,4.381,0,0,0,1.343,1.808.8.8,0,0,1,.445.911.846.846,0,0,1-.835.644H15.539a4.29,4.29,0,0,1-8.577,0Z",
  fill: "#622af2",
  stroke: "#622af2",
  strokeMiterlimit: 10,
  strokeWidth: 0.6
}));

function SvgNotification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.119,
    height: 28.725,
    viewBox: "0 0 23.119 28.725",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/Notification.e7148130.svg";
export { ForwardRef as ReactComponent };